export const navigationItemIdQueryParam = 'navId';
export const firstRouteQueryParam = 'isFirstRoute';
export const openAppQueryParam = 'openApp';
/**
 * sessionStorage-sleutel: app-interne route (hash-route zonder '#', bv. /shared/abc)
 * waar de login naartoe terugkeert. Gezet door publieke pagina's vóór "Inloggen"
 * (spec 2026-10-20-chart-share §4.3); per tab, één keer gebruikt.
 */
export const postLoginRedirectStorageKey = 'egi.postLoginRedirect';

/**
 * Display name used to identify the Platform Beheer app. This app is surfaced in the
 * user menu instead of the app selector, so both menus reference this single source.
 */
export const platformBeheerAppName = 'Platform Beheer';
